import React from "react";
import DashboardCards from "../../../components/DashboardCards";

const Dashboard = () => {
  return (
    <div className="p-8  h-screen">
      <h1 className="text-2xl font-bold mb-1">Dashboard</h1>
      <p className="mb-6">Welcome to the Pacific Cross Dashboard</p>
      <div className=" lg:h-[400px] 2xl:h-[500px]  rounded-lg">
        <DashboardCards />
      </div>
    </div>
  );
};

export default Dashboard;
